import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
} from "reactstrap"
import { get, put, post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useParams, useNavigate } from "react-router-dom"
import {
  UPDATE_PAYMENT_METHOD,
  LANGUAGES_SEARCH,
  SHOW_PAYMENT_METHOD,
  UPLOAD_FILE
} from "helpers/api_endpoints"
import Select from "react-select"
import { Trans } from "react-i18next"

document.title = "Edit Payment Method"
function EditPaymentMethod() {
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const [id, setid] = useState("")
  const [name, setName] = useState("")
  const [status, setStatus] = useState(0)
  const [symbol, setSymbol] = useState("")
  const [valued, setValued] = useState({ title: [] })
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    const getPaymentMethod = async () => {
      setLoading(true)
      try {
        const response = await get(`${SHOW_PAYMENT_METHOD}/${params.id}`)
        const paymentMethod = response.data
        setid(params.id)
        setName(paymentMethod.name)
        setStatus(paymentMethod.status)
        setSymbol(paymentMethod.symbol)
        if (paymentMethod.named && paymentMethod.named.title) {
          setValued(paymentMethod.named)
        } else {
          setValued({ title: [{ 1: paymentMethod.name }] })
        }
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    const getLanguages = async () => {
      setLoading(true)
      try {
        const response = await post(`${LANGUAGES_SEARCH}`, { status: 1 })
        const languages = response.data
        setLanguages(languages)
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    getPaymentMethod()
    getLanguages()
  }, [params.id])

  const handleSubmit = () => {
    put(UPDATE_PAYMENT_METHOD, { id, name, status: Number(status), symbol })
      .then(response => {
        if (response.code == 200) {
          navigate("/payment-methods", {
            state: { successMsg: "Payment Method Updated Successfully" },
          })
        }
      })
      .catch(error => {
        console.log(error)
        seterrorMsg(error.message)
      })
  }
  const handleName = (languageId, value) => {
    if (!valued.title) {
      const ob = {}
      ob[languageId] = value
      setValued({ title: [ob] })
      return
    }
    const ln = valued.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      valued.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(valued))
  }
  const handleFilter = (type, value) => {
    switch (type) {
      case "name": {
        break
      }
      default:
        break
    }
  }

  const clearPhoto = () => {
    if (image != "") setImage("")
  }

  const handleFileUpload = event => {
    const file = event.target.files[0]
    console.log(file.type)
    if (file.size > 1 * 1024 * 1024) {
      seterrorMsg("File size is larger than 1MB")
      setTimeout(() => {
        seterrorMsg("")
      }, 1700)
    }
    if (file.type != "image/jpeg" && file.type != "image/png") {
      seterrorMsg("File type is incorrect")
      setTimeout(() => {
        seterrorMsg("")
      }, 1700)
    }
    post(
      `${UPLOAD_FILE}`,
      { file, type: "payment-methods", fullPath: "true" },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then(response => {
        const data = response.data
        setSymbol(data.path)
      })
      .catch(error => {
        console.log(error)
      })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Countries" breadcrumbItem="Edit City" />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {errorMsg ? (
                        <Alert color="danger">{errorMsg}</Alert>
                      ) : null}
                      {languages.map((language, index) => (
                        <Row key={index}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Name ({language.name})</Trans>
                            </Label>
                            <Input
                              name="name"
                              value={
                                valued.title
                                  ? valued.title.find(el => {
                                      return el[language.id]
                                    })
                                    ? valued.title.find(el => {
                                        return el[language.id]
                                      })[language.id]
                                    : ""
                                  : JSON.stringify(valued)
                              }
                              className="form-control"
                              placeholder="Enter  Name"
                              type="text"
                              onChange={e =>
                                handleName(language.id, e.target.value)
                              }
                              required={
                                language.id == 1 || language.id == 2
                                  ? true
                                  : false
                              }
                            ></Input>
                          </div>
                        </Row>
                      ))}
                    </Row>
                    <Row>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Symbol</Trans>
                        </Label>
                        <Input
                          className="form-control"
                          type="file"
                          onChange={handleFileUpload}
                          required
                        ></Input>
                        <img src={symbol} className="w-100" />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <select
                          className="form-control"
                          value={status ?? ""}
                          onChange={e => setStatus(e.target.value)}
                          required
                        >
                          <option value=""></option>
                          <option value={1}>
                            <Trans>Active</Trans>
                          </option>
                          <option value={0}>
                            <Trans>Non Active</Trans>
                          </option>
                        </select>
                      </div>
                    </Row>
                    <div className="text-center  mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditPaymentMethod
